import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const MiniPc = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      {...rest}
      fill={fill}
    >
      <path d="M5.003 14.008H2.669a.333.333 0 1 1 0-.666h2.334a.333.333 0 1 1 0 .666ZM5.002 12.01H1.335a.333.333 0 0 1-.333-.334V2.343a.333.333 0 0 1 .333-.333h3.667a.333.333 0 1 1 0 .666H1.669v8.667h3.333a.333.333 0 1 1 0 .666ZM6.67.676h8.666a.333.333 0 0 1 .333.333v14a.333.333 0 0 1-.333.333H6.669a.333.333 0 0 1-.333-.334V1.01a.333.333 0 0 1 .333-.333Zm8.332.666h-8v13.333h8V1.342Z" />
      <path d="M12.336 4.342H9.669a.333.333 0 0 1 0-.666h2.667a.333.333 0 1 1 0 .666ZM12.336 7.008H9.669a.333.333 0 0 1 0-.666h2.667a.333.333 0 1 1 0 .666ZM11.003 9.008a1.667 1.667 0 1 1 0 3.333 1.667 1.667 0 0 1 0-3.333Zm0 2.666a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" />
    </svg>
  );
};

MiniPc.category = 'product-category';

MiniPc.displayName = 'MiniPc';
